import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { API_URL } from '../../config';
import { AssistantDevis } from './AssistantDevis';
import { useSiteSettings } from './siteSettings';

export const NAV_LINKS = [
  { path: '/sous-traitance-photovoltaique', label: 'Sous-traitance PV', sous: [
    ['/sous-traitance-photovoltaique', 'Présentation'], ['/grands-comptes', 'Grands comptes & EPC'],
    ['/prestations-photovoltaiques/chantier-complet', 'Chantier complet clé en main'], ['/prestations-photovoltaiques/renfort-equipes', "Renfort d'équipes"], ['/prestations-photovoltaiques/partenariat-installateurs', 'Partenariat installateurs'],
    ['/sous-traitance/hangars-agricoles', 'Hangars agricoles'], ['/sous-traitance/toitures-industrielles', 'Toitures industrielles'], ['/sous-traitance/ombrieres', 'Ombrières'], ['/sous-traitance/centrales-au-sol', 'Centrales au sol'],
    ['/references-photovoltaique', 'Références'], ['/reserver-equipe', 'Réserver une équipe'], ['/dossier-fournisseur', 'Dossier fournisseur'] ] },
  { path: '/nos-realisations', label: 'Réalisations' },
  { path: '/qui-sommes-nous', label: 'Entreprise', sous: [
    ['/qui-sommes-nous', 'Qui sommes-nous'], ['/qualifications', 'Qualifications & assurances'], ['/disponibilites', 'Disponibilités des équipes'], ['/documents', 'Documents'], ['/recrutement', 'On recrute'] ] },
  { path: '/professionnels', label: 'Autres services', sous: [
    ['/professionnels/photovoltaique', 'Solaire pour entreprises'], ['/nos-activites/maintenance', 'Maintenance photovoltaïque'],
    ['/nos-activites/irve', 'Bornes de recharge IRVE'], ['/nos-activites/electricite', 'Électricité & réseaux'], ['/nos-activites/ftth', 'Fibre optique FTTH'],
    ['/particuliers', 'Particuliers (Nouvelle-Aquitaine)'], ['/visite-technique', 'Visite technique gratuite'] ] },
  { path: '/contact',          label: 'Contact' },
];


const PAGE_META = [
  ['/activites', 'Nos activités — Électricité, photovoltaïque, IRVE, PAC, fibre', "Les 6 domaines d'EVOLINK : électricité et éclairage, photovoltaïque, génie climatique, bornes IRVE, énergies renouvelables et fibre optique."],
  ['/nos-activites/photovoltaique', 'Sous-traitance photovoltaïque — pose, câblage, mise en service', 'Calepinage, pose des structures et modules, chemins de câbles, câblage DC/AC et mise en service pour EPC et installateurs.'],
  ['/nos-activites/ftth', 'Sous-traitance fibre optique FTTH', 'Raccordements FTTH, tirage, soudure et mise en service de box pour opérateurs et fournisseurs d\'accès.'],
  ['/nos-activites', 'Sous-traitance photovoltaïque, IRVE, électricité et télécom', "Sous-traitance pour EPC, installateurs, opérateurs et entreprises générales partout en France : photovoltaïque, bornes IRVE, électricité, fibre FTTH, génie climatique."],
  ['/sous-traitance/ombrieres', 'Sous-traitance ombrières photovoltaïques', 'Montage, pose de modules bifaciaux et câblage d\'ombrières photovoltaïques de parking.'],
  ['/sous-traitance/hangars-agricoles', 'Sous-traitance hangars agricoles photovoltaïques', 'Pose de centrales sur hangars agricoles bac acier : sécurité, pose, câblage et raccordement.'],
  ['/sous-traitance/toitures-industrielles', 'Sous-traitance toitures industrielles photovoltaïques', 'Centrales en toiture d\'entrepôts et bâtiments industriels, surimposition et systèmes lestés.'],
  ['/sous-traitance/centrales-au-sol', 'Sous-traitance centrales photovoltaïques au sol', 'Renfort d\'équipes pour la pose des tables, des modules et le câblage des centrales au sol.'],
  ['/nos-realisations', 'Nos réalisations — chantiers photovoltaïques', 'Ombrières, hangars agricoles et toitures : les chantiers réalisés par EVOLINK partout en France.'],
  ['/qui-sommes-nous', 'Qui sommes-nous', 'EVOLINK, entreprise de sous-traitance photovoltaïque et FTTH : 10 ans d\'expérience, 55 MWc installés, RGE QualiPV 500.'],
  ['/devis', 'Nous consulter — chiffrage sous 48 h', 'Décrivez votre chantier : type, puissance, prestations, région. Chiffrage sous 48 h ouvrées.'],
  ['/contact', 'Contact', 'Contactez EVOLINK, sous-traitant photovoltaïque partout en France : 06 66 88 77 66 · contact@evolinkpro.com. Réponse rapide, chiffrage sous 48 h sur plans.'],
  ['/recrutement', 'Recrutement — poseurs, câbleurs, techniciens', 'EVOLINK recrute poseurs photovoltaïques, câbleurs DC/AC, chefs d\'équipe et techniciens FTTH.'],
  ['/devenir-partenaire', 'Devenir partenaire poseur photovoltaïque', "Poseurs et entreprises de pose photovoltaïque : rejoignez le réseau de partenaires EVOLINK et recevez des chantiers partout en France. Candidature en ligne (Kbis, URSSAF, assurances)."],
  ['/simulateur', 'Simulateur de délai sous-traitance photovoltaïque', 'Estimez en 30 secondes le délai de pose de votre centrale photovoltaïque en sous-traitance.'],
  ['/jeu', 'Jeu : posez une centrale photovoltaïque en 2 minutes', 'Calepinage et câblage des strings : relevez le défi de l\'installateur photovoltaïque en 2 minutes.'],
  ['/jeu-expert', 'Jeu expert : centrale de 500 kWc en 10 minutes', 'Dimensionnement, fixation, calepinage, strings, onduleurs et QCM : le test complet de l\'installateur photovoltaïque.'],
  ['/guides', 'Guides de la sous-traitance photovoltaïque', 'Choisir un sous-traitant, étapes d\'un chantier, ombrières, hangars, câblage DC, mise en service, DOE, contrat.'],
  ['/formation', 'Formation installateur photovoltaïque et électricité', '16 modules en 4 mois, quiz, examen final et attestation EVOLINK vérifiable.'],
  ['/faq', 'FAQ sous-traitance photovoltaïque', 'Délais, prestations, normes, sécurité, assurance, TVA autoliquidée : les réponses aux questions des EPC.'],
  ['/pourquoi-evolink', 'Pourquoi choisir EVOLINK', 'Cadence, chiffrage sous 48 h, autocontrôles signés, sécurité, suivi en ligne.'],
  ['/rendez-vous', 'Réserver un appel', 'Réservez un appel de 15 minutes avec EVOLINK.'],
  ['/disponibilites', 'Disponibilités des équipes de pose PV', 'Équipes de pose photovoltaïque disponibles par semaine et par région.'],
  ['/documents', 'Documents administratifs — Kbis, décennale, URSSAF', "Kbis, assurance décennale, RC Pro, attestation URSSAF, habilitations : le dossier sous-traitant d'EVOLINK."],
  ['/mentions-legales', 'Mentions légales', 'Mentions légales du site evolinkpro.com : éditeur EVOLINK SASU, hébergement, données personnelles et propriété intellectuelle.'],
  ['/cgu', "Conditions générales d'utilisation", "CGU de l'espace professionnel EVOLINK."],
];
const DEFAULT_META = ['Sous-traitance photovoltaïque partout en France | EVOLINK', "Sous-traitant photovoltaïque pour installateurs et EPC partout en France : pose de structures et de panneaux, câblage DC/AC, mise en service, maintenance. Aussi IRVE, électricité, fibre. Particuliers en Gironde. RGE QualiPV 500, 55 MWc."];

/* ── Design system EVOLINK (injecté une fois) ── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@500;600;700;800;900&family=Inter:wght@400;500;600;700&display=swap');

:root{
  --ev-navy:#0B1B4D; --ev-navy2:#07123A; --ev-blue:#002FA7; --ev-blue2:#1D4ED8;
  --ev-sun:#F5B301; --ev-sun2:#E09A00;
  --ev-ink:#111827; --ev-muted:#5B6477; --ev-line:#E5E8EF; --ev-bg2:#F4F6FA;
  --ev-h:'Montserrat',sans-serif; --ev-b:'Inter',sans-serif;
}
.ev-site{font-family:var(--ev-b);color:var(--ev-ink);background:#fff;overflow-x:hidden}
.ev-site *{box-sizing:border-box}
.ev-site h1,.ev-site h2,.ev-site h3,.ev-site h4{font-family:var(--ev-h);margin:0}
.ev-site p{margin:0}
.ev-wrap{max-width:1200px;margin:0 auto;padding:0 24px}
.ev-sec{padding:96px 0}
.ev-sec.alt{background:var(--ev-bg2)}
.ev-sec.dark{background:var(--ev-navy);color:#fff}

/* titres de section */
.ev-kicker{display:inline-flex;align-items:center;gap:10px;font-family:var(--ev-h);font-weight:700;font-size:.78rem;letter-spacing:.18em;text-transform:uppercase;color:#9A6400;margin-bottom:14px}
.ev-kicker::before{content:'';width:28px;height:3px;background:var(--ev-sun);border-radius:2px}
.ev-title{font-weight:800;font-size:clamp(1.8rem,3.6vw,2.7rem);line-height:1.15;letter-spacing:-.01em;color:var(--ev-navy)}
.ev-title span{color:var(--ev-blue)}
.ev-site .ev-title{font-size:clamp(1.7rem,3.6vw,2.7rem)!important;line-height:1.15!important}
.ev-site .h-title{font-size:clamp(2.2rem,6vw,4.6rem)!important;line-height:1.02!important}
.ev-site .h3-title{font-size:clamp(2.3rem,5.2vw,4.3rem)!important;line-height:1.02!important}
.ev-site .s-hero h1,.ev-site .ev-h1{font-size:clamp(2rem,5vw,3.6rem)!important;line-height:1.05!important}
.dark .ev-title,.ev-title.light{color:#fff}
.dark .ev-title span,.ev-title.light span{color:var(--ev-sun)}
.ev-lead{font-size:1.02rem;line-height:1.85;color:var(--ev-muted);margin-top:18px;max-width:640px}
.dark .ev-lead{color:rgba(255,255,255,.72)}
.ev-center{text-align:center}
.ev-center .ev-lead{margin-left:auto;margin-right:auto}
.ev-center .ev-kicker{justify-content:center}

/* boutons */
.ev-btn{display:inline-flex;align-items:center;gap:10px;padding:15px 30px;border-radius:4px;font-family:var(--ev-h);font-weight:700;font-size:.85rem;letter-spacing:.06em;text-transform:uppercase;text-decoration:none;transition:all .25s;border:2px solid transparent;cursor:pointer}
.ev-btn-sun{background:var(--ev-sun);color:var(--ev-navy)}
.ev-btn-sun:hover{background:#fff;color:var(--ev-navy);transform:translateY(-2px)}
.ev-btn-blue{background:var(--ev-blue);color:#fff}
.ev-btn-blue:hover{background:var(--ev-navy);transform:translateY(-2px)}
.ev-btn-ghost{border-color:rgba(255,255,255,.7);color:#fff}
.ev-btn-ghost:hover{background:#fff;color:var(--ev-navy)}

/* masque le badge de l'espace pro sur le site public */
body:has(.ev-site)::after{display:none!important;content:none!important}

/* topbar */
#ev-topbar{background:var(--ev-navy2);color:rgba(255,255,255,.75);font-size:.78rem}
#ev-topbar .ev-wrap{display:flex;justify-content:space-between;align-items:center;height:42px;gap:20px}
#ev-topbar a{color:rgba(255,255,255,.8);text-decoration:none;transition:color .2s}
#ev-topbar a:hover{color:var(--ev-sun)}
.ev-tb-left{display:flex;gap:26px;align-items:center}
.ev-tb-tag{font-family:var(--ev-h);font-weight:700;font-size:.68rem;letter-spacing:.14em;color:var(--ev-sun);text-transform:uppercase}

/* nav */
#ev-nav{position:sticky;top:0;z-index:500;background:#fff;border-bottom:1px solid var(--ev-line);transition:box-shadow .3s}
#ev-nav.scrolled{box-shadow:0 6px 30px rgba(11,27,77,.08)}
#ev-nav .ev-wrap{display:flex;align-items:center;justify-content:space-between;height:84px}
.ev-logo{display:flex;align-items:center;gap:12px;text-decoration:none}
.ev-logo-mark{width:52px;height:52px;flex-shrink:0;display:block;transition:transform .6s cubic-bezier(.16,1,.3,1)}
.ev-logo:hover .ev-logo-mark{transform:rotate(120deg)}
.ev-logo-name .lk{color:var(--ev-blue)}
.ev-logo-name{font-family:var(--ev-h);font-weight:900;font-size:1.35rem;letter-spacing:.02em;color:var(--ev-navy);line-height:1;display:block}
.ev-logo-sub{white-space:nowrap;font-family:var(--ev-h);font-size:.6rem;font-weight:700;letter-spacing:.2em;color:#9A6400;text-transform:uppercase}
.ev-links{display:flex;list-style:none;margin:0;padding:0;gap:4px}
.ev-link{display:block;white-space:nowrap;padding:10px 9px;font-family:var(--ev-h);font-weight:700;font-size:.76rem;letter-spacing:.06em;text-transform:uppercase;color:var(--ev-navy);text-decoration:none;position:relative;transition:color .2s}
.ev-link::after{content:'';position:absolute;left:9px;right:9px;bottom:2px;height:3px;background:var(--ev-sun);transform:scaleX(0);transition:transform .25s;transform-origin:left}
.ev-link:hover,.ev-link.active{color:var(--ev-blue)}
.ev-link:hover::after,.ev-link.active::after{transform:scaleX(1)}
.ev-nav-cta{padding:13px 18px!important;font-size:.72rem!important;white-space:nowrap}
.ev-has-sub{position:relative}
.ev-caret{font-size:.7em;margin-left:4px;opacity:.7}
.ev-sub{position:absolute;top:100%;left:0;padding-top:10px;opacity:0;visibility:hidden;transform:translateY(6px);transition:opacity .18s,transform .18s,visibility .18s;z-index:600}
.ev-has-sub:hover .ev-sub,.ev-has-sub:focus-within .ev-sub{opacity:1;visibility:visible;transform:none}
.ev-sub-in{background:var(--ev-sun);min-width:250px;padding:8px 0;box-shadow:0 18px 40px rgba(11,27,77,.18);border-radius:4px}
.ev-sub-link{display:block;padding:10px 20px;font-family:var(--ev-b,inherit);font-size:.9rem;font-weight:600;color:var(--ev-navy);text-decoration:none;white-space:nowrap}
.ev-sub-link:hover{background:rgba(255,255,255,.35);color:var(--ev-navy)}
.ev-drawer-group summary{list-style:none;cursor:pointer}
.ev-drawer-group summary::-webkit-details-marker{display:none}
.ev-drawer-sub{display:block;padding:10px 0 10px 14px;color:rgba(255,255,255,.85);text-decoration:none;font-size:.92rem;border-bottom:1px solid rgba(255,255,255,.05)}
.ev-burger{display:none;background:none;border:none;cursor:pointer;padding:8px;color:var(--ev-navy)}

/* drawer */
#ev-drawer{position:fixed;inset:0;z-index:9000;pointer-events:none;opacity:0;transition:opacity .3s}
#ev-drawer.open{pointer-events:all;opacity:1}
.ev-drawer-bg{position:absolute;inset:0;background:rgba(7,18,58,.6)}
.ev-drawer-panel{position:absolute;top:0;right:0;bottom:0;width:min(88vw,340px);background:var(--ev-navy);padding:28px;overflow:auto;transform:translateX(100%);transition:transform .35s cubic-bezier(.16,1,.3,1)}
#ev-drawer.open .ev-drawer-panel{transform:none}
.ev-drawer-link{display:block;padding:15px 0;border-bottom:1px solid rgba(255,255,255,.08);font-family:var(--ev-h);font-weight:700;font-size:.9rem;letter-spacing:.06em;text-transform:uppercase;color:#fff;text-decoration:none}
.ev-drawer-link.active{color:var(--ev-sun)}

/* footer */
@media(max-width:1500px){.ev-tb-wide{display:none!important}}
.ev-footer{background:var(--ev-navy2);color:rgba(255,255,255,.7);padding:80px 0 0}
.ev-footer .ev-logo-sub{color:var(--ev-sun)}
.ev-footer-grid{display:grid;grid-template-columns:1.6fr 1fr 1fr 1.3fr;gap:48px;padding-bottom:56px}
.ev-footer h4{font-weight:800;font-size:.85rem;letter-spacing:.12em;text-transform:uppercase;color:#fff;margin-bottom:22px;padding-bottom:12px;position:relative}
.ev-footer h4::after{content:'';position:absolute;left:0;bottom:0;width:30px;height:3px;background:var(--ev-sun)}
.ev-footer ul{list-style:none;margin:0;padding:0}
.ev-footer li{margin-bottom:11px}
.ev-footer a{color:rgba(255,255,255,.7);text-decoration:none;font-size:.88rem;transition:color .2s}
.ev-footer a:hover{color:var(--ev-sun)}
.ev-footer-txt{font-size:.9rem;line-height:1.85;max-width:300px;margin-top:18px}
.ev-footer-row{display:flex;gap:12px;margin-bottom:14px;font-size:.88rem;line-height:1.6}
.ev-footer-row b{color:var(--ev-sun);min-width:18px}
.ev-footer-bottom{border-top:1px solid rgba(255,255,255,.08);padding:22px 0;display:flex;justify-content:space-between;flex-wrap:wrap;gap:12px;font-size:.78rem;color:rgba(255,255,255,.72)}
.ev-social{display:flex;gap:8px;margin-top:22px}
.ev-social a{width:38px;height:38px;border-radius:4px;border:1px solid rgba(255,255,255,.15);display:flex;align-items:center;justify-content:center;font-weight:700;font-size:.8rem}
.ev-social a:hover{background:var(--ev-sun);color:var(--ev-navy);border-color:var(--ev-sun)}

.ev-call{display:none;position:fixed;left:16px;bottom:22px;z-index:8000;align-items:center;gap:8px;padding:0 20px;height:52px;border-radius:26px;background:var(--ev-blue);color:#fff;font-family:var(--ev-h);font-weight:800;font-size:.85rem;letter-spacing:.06em;text-transform:uppercase;text-decoration:none;box-shadow:0 6px 20px rgba(0,47,167,.45)}
.ev-wa{position:fixed;bottom:22px;right:22px;z-index:8000;width:56px;height:56px;border-radius:50%;background:#25D366;color:#fff;display:flex;align-items:center;justify-content:center;box-shadow:0 6px 20px rgba(37,211,102,.45);text-decoration:none;transition:transform .2s}
.ev-wa:hover{transform:scale(1.08)}

@media(max-width:1260px){
  .ev-links,.ev-nav-cta{display:none!important}
  .ev-burger{display:flex}
  .ev-tb-hide{display:none}
  .ev-footer-grid{grid-template-columns:1fr 1fr}
}
@media(max-width:640px){
  .ev-call{display:flex}
  .ev-sec{padding:64px 0}
  #ev-topbar{display:none}
  #ev-nav .ev-wrap{height:70px}
  .ev-footer-grid{grid-template-columns:1fr}
}
`;

/* Profil du visiteur (particulier / pro / donneur d'ordre) : retenu sur son téléphone pour adapter le bouton « Devis » et l'accueil */
export function lireProfil() { try { return localStorage.getItem('ev_profil') || ''; } catch (e) { return ''; } }
export function ecrireProfil(p) { try { if (p) localStorage.setItem('ev_profil', p); else localStorage.removeItem('ev_profil'); } catch (e) { /* navigation privée */ } }
const PROFIL_DE_PAGE = [
  [/^\/(particuliers|simulateur-solaire|aides-2026|conseils|etude-photo|parrainage|panneaux-solaires|visite-technique)/, 'particulier'],
  [/^\/professionnels/, 'pro'],
  [/^\/(nos-activites|sous-traitance-photovoltaique|sous-traitance|devis$|simulateur$|disponibilites|documents|devenir-partenaire)/, 'donneur'],
];
export const CTA_PROFIL = {
  particulier: { to: '/visite-technique', l: 'Visite gratuite' },
  pro: { to: '/professionnels#demande', l: 'Devis gratuit' },
  donneur: { to: '/devis', l: 'Nous consulter' },
  '': { to: '/devis', l: 'Demander un devis' },
};

export const SiteLayout = ({ children, title, description, noindex = false }) => {
  const location = useLocation();
  const reglages = useSiteSettings();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [profil, setProfil] = useState(lireProfil());
  useEffect(() => {
    const hit = PROFIL_DE_PAGE.find(([re]) => re.test(location.pathname));
    if (hit && hit[1] !== lireProfil()) { ecrireProfil(hit[1]); setProfil(hit[1]); }
  }, [location.pathname]);
  const cta = CTA_PROFIL[profil] || CTA_PROFIL[''];

  useEffect(() => {
    let s = document.getElementById('ev-sl-css');
    if (!s) { s = document.createElement('style'); s.id = 'ev-sl-css'; document.head.appendChild(s); }
    s.textContent = CSS;
  }, []);

  /* Site public : zoom autorisé (accessibilité). L'espace admin / tech garde le blocage du zoom. */
  useEffect(() => {
    const m = document.querySelector('meta[name="viewport"]');
    if (!m) return undefined;
    const avant = m.getAttribute('content');
    m.setAttribute('content', 'width=device-width, initial-scale=1');
    return () => { if (avant) m.setAttribute('content', avant); };
  }, []);


  /* Résultats du site : une visite par page, et les clics Appeler / WhatsApp / email (sans cookie, sans donnée personnelle) */
  useEffect(() => {
    try {
      const env = (e) => { const d = JSON.stringify({ e, p: window.location.pathname, r: e === 'vue' ? document.referrer : '' });
        if (navigator.sendBeacon) navigator.sendBeacon(`${API_URL}/stats/evt`, new Blob([d], { type: 'text/plain' })); };
      env('vue');
      if (!window.__evClics) {
        window.__evClics = true;
        document.addEventListener('click', (ev) => {
          const a = ev.target && ev.target.closest && ev.target.closest('a[href]');
          if (!a) return;
          const h = a.getAttribute('href') || '';
          if (h.startsWith('tel:')) env('appel'); else if (/wa\.me|whatsapp/i.test(h)) env('whatsapp'); else if (h.startsWith('mailto:')) env('email');
        }, true);
      }
    } catch (e) { /* jamais bloquant */ }
  }, [location.pathname]);

  /* Titre et description de chaque page (Google) */
  useEffect(() => {
    const path = location.pathname;
    let t = DEFAULT_META[0], d = DEFAULT_META[1];
    const hit = PAGE_META.find(([p]) => path === p || path.startsWith(p + '/'));
    const suffixe = (x) => (x.length > 52 ? x : `${x} | EVOLINK`); // Google coupe vers 60 caractères
    if (hit) { t = suffixe(hit[1]); d = hit[2]; }
    if (title) { t = suffixe(title); }
    if (description) { d = description; }
    document.title = t;
    const m = document.querySelector('meta[name="description"]');
    if (m) m.setAttribute('content', d);
    let rb = document.querySelector('meta[name="robots"]');
    if (noindex) { if (!rb) { rb = document.createElement('meta'); rb.setAttribute('name', 'robots'); document.head.appendChild(rb); } rb.setAttribute('content', 'noindex, follow'); }
    else if (rb && rb.getAttribute('content') === 'noindex, follow') rb.remove();
  }, [location.pathname, title, description, noindex]);

  /* Fil d'Ariane lu par Google (BreadcrumbList) : Accueil > rubrique > page */
  useEffect(() => {
    const path = location.pathname.replace(/\/+$/, '');
    let s = document.getElementById('ld-breadcrumb');
    if (!path || path.startsWith('/guides/')) { if (s) s.remove(); return undefined; }
    const tm = setTimeout(() => {
      const SITE = 'https://www.evolinkpro.com';
      const nomDe = (seg) => { const hit = PAGE_META.find(([p]) => p === seg); return hit ? hit[1].split(/ [—:|] /)[0] : seg.split('/').pop().replace(/-/g, ' ').replace(/^./, c => c.toUpperCase()); };
      const segs = path.split('/').filter(Boolean);
      const items = [{ '@type': 'ListItem', position: 1, name: 'Accueil', item: SITE + '/' }];
      const connue = (p) => PAGE_META.some(([x]) => x === p) || NAV_LINKS.some(l => l.path === p);
      segs.forEach((_, i) => {
        const p = '/' + segs.slice(0, i + 1).join('/');
        const dernier = i === segs.length - 1;
        if (!dernier && !connue(p)) return;
        const h1 = dernier && document.querySelector('h1');
        items.push({ '@type': 'ListItem', position: items.length + 1, name: ((h1 && h1.textContent.trim()) || nomDe(p)).slice(0, 80), item: SITE + p });
      });
      if (!s) { s = document.createElement('script'); s.type = 'application/ld+json'; s.id = 'ld-breadcrumb'; document.head.appendChild(s); }
      s.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'BreadcrumbList', itemListElement: items });
    }, 400);
    return () => clearTimeout(tm);
  }, [location.pathname]);

  /* Effet 3D : les cartes s'inclinent sous la souris */
  useEffect(() => {
    if (window.matchMedia && (window.matchMedia('(hover: none)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    const SEL = '.h-card,.s-card,.r-card,.h-why-item,.a-pole,.h-proc-step';
    let cur = null;
    const reset = (el) => { el.style.transform = ''; el.style.transition = 'transform .5s cubic-bezier(.16,1,.3,1)'; };
    const move = (e) => {
      const el = e.target.closest && e.target.closest(SEL);
      if (cur && cur !== el) { reset(cur); cur = null; }
      if (!el) return;
      cur = el;
      const r = el.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      const amp = el.classList.contains('a-pole') ? 3 : 9;
      el.style.transition = 'transform .08s linear';
      el.style.transform = `perspective(900px) rotateX(${(-y * amp).toFixed(2)}deg) rotateY(${(x * amp).toFixed(2)}deg) translateY(-6px)`;
    };
    const leave = () => { if (cur) { reset(cur); cur = null; } };
    document.addEventListener('mousemove', move, { passive: true });
    document.addEventListener('mouseleave', leave);
    return () => { document.removeEventListener('mousemove', move); document.removeEventListener('mouseleave', leave); };
  }, []);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', fn, { passive: true });
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
    if (location.hash) {
      const id = location.hash.slice(1);
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 120);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);

  const isActive = (path) => {
    if (path.includes('#')) return location.pathname === '/' && location.hash === path.slice(1);
    if (path === '/') return location.pathname === '/' && !location.hash;
    return location.pathname.startsWith(path);
  };

  return (
    <div className="ev-site">
      {/* Topbar */}
      <div id="ev-topbar">
        <div className="ev-wrap">
          <div className="ev-tb-left">
            <a href="tel:+33666887766">📞 06 66 88 77 66</a>
            <a href="mailto:contact@evolinkpro.com">✉ contact@evolinkpro.com</a>
          </div>
          <div style={{ display:'flex', gap:22, alignItems:'center' }}>
            {profil === 'donneur'
              ? <Link to="/simulateur" className="ev-tb-hide" style={{ fontWeight:700, color:'var(--ev-sun)' }}>⚡ Simulateur de délai</Link>
              : <Link to="/simulateur-solaire" className="ev-tb-hide" style={{ fontWeight:700, color:'var(--ev-sun)' }}>☀️ Simulateur solaire</Link>}
            <Link to="/en" className="ev-tb-hide" title="English version" style={{ fontWeight:700 }}>🇬🇧 EN</Link>
            <Link to="/login" style={{ fontWeight:600 }}>Espace Pro →</Link>
          </div>
        </div>
      </div>

      {/* Nav */}
      <nav id="ev-nav" className={scrolled ? 'scrolled' : ''}>
        <div className="ev-wrap">
          <Link to="/" className="ev-logo">
            <img className="ev-logo-mark" src={`${process.env.PUBLIC_URL}/img/logo-mark.svg`} alt="" width="52" height="52" />
            <div>
              <span className="ev-logo-name">EVO<span className="lk">LINK</span></span>
              <span className="ev-logo-sub">Solaire · IRVE · Électricité</span>
            </div>
          </Link>

          <ul className="ev-links">
            {NAV_LINKS.map(({ path, label, sous }) => (
              <li key={path} className={sous ? 'ev-has-sub' : ''}>
                <Link to={path} className={`ev-link${isActive(path) ? ' active' : ''}`}>{label}{sous && <span className="ev-caret">▾</span>}</Link>
                {sous && <div className="ev-sub"><div className="ev-sub-in">{sous.map(([to, l]) => <Link key={to} to={to} className="ev-sub-link">{l}</Link>)}</div></div>}
              </li>
            ))}
          </ul>

          <Link to={cta.to} className="ev-btn ev-btn-blue ev-nav-cta">{cta.l}</Link>

          <button className="ev-burger" aria-label="Menu" onClick={() => setMenuOpen(o => !o)}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
              {menuOpen ? <><path d="M18 6L6 18"/><path d="M6 6l12 12"/></> : <><path d="M4 6h16"/><path d="M4 12h16"/><path d="M4 18h16"/></>}
            </svg>
          </button>
        </div>
      </nav>

      {/* Drawer mobile */}
      <div id="ev-drawer" className={menuOpen ? 'open' : ''}>
        <div className="ev-drawer-bg" onClick={() => setMenuOpen(false)} />
        <div className="ev-drawer-panel">
          <div style={{ display:'flex', alignItems:'center', gap:10, fontFamily:'var(--ev-h)', fontWeight:900, fontSize:'1.3rem', color:'#fff', marginBottom:4 }}><img src={`${process.env.PUBLIC_URL}/img/logo-mark.svg`} alt="" width="38" height="38" />EVO<span style={{ color:'#8fb2ff', marginLeft:-10 }}>LINK</span></div>
          <div style={{ fontSize:'.7rem', letterSpacing:'.16em', color:'var(--ev-sun)', fontWeight:700, marginBottom:28, textTransform:'uppercase' }}>Solaire · IRVE · Électricité</div>
          <Link to={cta.to} className="ev-btn ev-btn-sun" style={{ marginBottom:18, width:'100%', justifyContent:'center' }}>{cta.l} →</Link>
          {NAV_LINKS.map(({ path, label, sous }) => sous ? (
            <details key={path} className="ev-drawer-group">
              <summary className={`ev-drawer-link${isActive(path) ? ' active' : ''}`}>{label} <span style={{ float: 'right' }}>▾</span></summary>
              <Link to={path} className="ev-drawer-sub" style={{ fontWeight: 800 }}>Voir tout : {label}</Link>
              {sous.map(([to, l]) => <Link key={to} to={to} className="ev-drawer-sub">{l}</Link>)}
            </details>
          ) : (
            <Link key={path} to={path} className={`ev-drawer-link${isActive(path) ? ' active' : ''}`}>{label}</Link>
          ))}
          {(profil === 'donneur' ? [
            ['/sous-traitance-photovoltaique', '🗺 Sous-traitance PV par région'], ['/fibre-optique-ftth-gironde', '🔌 Fibre optique FTTH'], ['/simulateur', '⚡ Simulateur de délai'], ['/disponibilites', '📆 Disponibilités des équipes'], ['/documents', '📁 Documents administratifs'], ['/rendez-vous', '📅 Réserver un appel'],
          ] : profil === 'pro' ? [
            ['/visite-technique', '📅 Visite technique gratuite'], ['/qualifications', '🏅 Qualifications & assurances'], ['/rendez-vous', '📞 Réserver un appel'],
          ] : [
            ['/simulateur-solaire', '☀️ Simulateur solaire'], ['/aides-2026', '💶 Aides 2026'], ['/conseils', '📚 Conseils'], ['/etude-photo', '📷 Devis sur photos'], ['/qualifications', '🏅 Qualifications & assurances'],
          ]).map(([to, l]) => <Link key={to} to={to} className="ev-drawer-link">{l}</Link>)}
          <Link to="/faq" className="ev-drawer-link">❓ FAQ</Link>
          <a href="tel:+33666887766" style={{ display:'block', marginTop:22, color:'#fff', fontWeight:800, fontSize:'1.1rem', textDecoration:'none' }}>📞 06 66 88 77 66</a>
        </div>
      </div>

      <main>{children}</main>

      {/* Assistant devis express */}
      {!/^\/(devis|jeu|jeu-expert|en)/.test(location.pathname) && <AssistantDevis />}

      {/* Appel (mobile) */}
      <a className="ev-call" href="tel:+33666887766">📞 Appeler</a>

      {/* WhatsApp */}
      <a className="ev-wa" href="https://wa.me/33666887766?text=Bonjour%20EVOLINK%2C%20je%20souhaite%20un%20devis%20pour%20mon%20projet."
        target="_blank" rel="noopener noreferrer" title="WhatsApp">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="#fff"><path d="M17.5 14.4c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.7.1-.2.3-.8.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.2-.5-2.3-1.4-.9-.8-1.4-1.7-1.6-2-.2-.3 0-.5.1-.6l.4-.5c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5l-.9-2.2c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.4s1 2.8 1.2 3c.1.2 2 3.1 4.9 4.3 2.4 1 2.9.8 3.4.7.5-.1 1.7-.7 2-1.4.2-.7.2-1.2.2-1.4-.1-.1-.3-.2-.6-.3zM12 2a10 10 0 00-8.6 15.1L2 22l5-1.3A10 10 0 1012 2z"/></svg>
      </a>

      {/* Footer */}
      <footer className="ev-footer">
        <div className="ev-wrap">
          <div className="ev-footer-grid">
            <div>
              <div className="ev-logo" style={{ pointerEvents:'none' }}>
                <img className="ev-logo-mark" src={`${process.env.PUBLIC_URL}/img/logo-mark.svg`} alt="" width="52" height="52" />
                <div>
                  <span className="ev-logo-name" style={{ color:'#fff' }}>EVO<span style={{ color:'#8fb2ff' }}>LINK</span></span>
                  <span className="ev-logo-sub">Solaire · IRVE · Électricité</span>
                </div>
              </div>
              <p className="ev-footer-txt">
                EVOLINK réalise en sous-traitance la pose et le câblage de centrales photovoltaïques pour les EPC, installateurs et opérateurs, et équipe entreprises, agriculteurs et particuliers en solaire, bornes de recharge et électricité, partout en France.
              </p>
              <div className="ev-social">
                <a href="https://fr.linkedin.com/company/evolinkpro" target="_blank" rel="noopener noreferrer" title="LinkedIn">in</a>
                <a href="https://www.facebook.com/evolinkpro" target="_blank" rel="noopener noreferrer" title="Facebook">f</a>
                <a href="https://wa.me/33666887766" target="_blank" rel="noopener noreferrer" title="WhatsApp">W</a>
              </div>
              <div style={{ marginTop: 16 }}><div className="ev-footer-row"><b>📍</b><span>60 rue François 1er<br/>75008 Paris</span></div>
              <div className="ev-footer-row"><b>📞</b><a href="tel:+33666887766">06 66 88 77 66</a></div>
              <div className="ev-footer-row"><b>✉</b><a href="mailto:contact@evolinkpro.com">contact@evolinkpro.com</a></div>
              <div className="ev-footer-row"><b>🕐</b><span>Lun – Sam : 7h00 – 19h00</span></div></div>
              {reglages.google_url && <a href={reglages.google_url} target="_blank" rel="noopener noreferrer" style={{ display: 'inline-block', marginTop: 14, background: '#F5B301', color: '#0B1B4D', fontWeight: 800, padding: '9px 14px', borderRadius: 6, textDecoration: 'none', fontSize: 14 }}>⭐ Laisser un avis Google</a>}
            </div>
            <div>
              <h4>Sous-traitance</h4>
              <ul>
                {[['/sous-traitance-photovoltaique','Sous-traitance photovoltaïque'],['/prestations-photovoltaiques/chantier-complet','Chantier complet clé en main'],['/prestations-photovoltaiques/renfort-equipes',"Renfort d'équipes"],['/grands-comptes','Grands comptes / EPC'],['/references-photovoltaique','Références'],['/reserver-equipe','Réserver une équipe'],['/disponibilites','Disponibilités'],['/dossier-fournisseur','Dossier fournisseur'],['/devis','Envoyer un projet']].map(([p,l]) => (
                  <li key={p}><Link to={p}>{l}</Link></li>
                ))}
              </ul>
            </div>
            <div>
              <h4>Autres services</h4>
              <ul>
                {[['/professionnels/photovoltaique','Solaire pour entreprises'],['/nos-activites/maintenance','Maintenance photovoltaïque'],['/nos-activites/irve','Bornes de recharge IRVE'],['/nos-activites/electricite','Électricité & réseaux'],['/nos-activites/ftth','Fibre optique FTTH'],['/particuliers','Particuliers (Nouvelle-Aquitaine)'],['/visite-technique','Visite technique gratuite']].map(([p,l]) => (
                  <li key={p}><Link to={p}>{l}</Link></li>
                ))}
              </ul>
            </div>
            <div>
              <h4>EVOLINK</h4>
              <ul>
                {[['/qui-sommes-nous','Qui sommes-nous'],['/nos-realisations','Réalisations'],['/qualifications','Qualifications & assurances'],['/documents','Documents administratifs'],['/guides','Guides techniques'],['/faq','FAQ'],['/recrutement','On recrute'],['/contact','Contact'],['/login','Espace Pro']].map(([p,l]) => (
                  <li key={p}><Link to={p}>{l}</Link></li>
                ))}
              </ul>
            </div>
          </div>
          <details style={{ marginTop: 26, borderTop: '1px solid rgba(255,255,255,.1)', paddingTop: 14 }}>
            <summary style={{ cursor: 'pointer', color: 'rgba(255,255,255,.7)', fontWeight: 700, fontSize: 14 }}>Toutes nos pages et zones d'intervention</summary>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px 18px', marginTop: 12, fontSize: 13 }}>
              {[['/sous-traitance/hangars-agricoles','Hangars agricoles'],['/sous-traitance/toitures-industrielles','Toitures industrielles'],['/sous-traitance/ombrieres','Ombrières'],['/sous-traitance/centrales-au-sol','Centrales au sol'],['/prestations-photovoltaiques/partenariat-installateurs','Partenariat installateurs'],['/panneaux-solaires-nouvelle-aquitaine','Panneaux solaires Nouvelle-Aquitaine'],['/particuliers/entretien-panneaux-solaires','Nettoyage & réparation solaire'],['/simulateur-solaire','Simulateur solaire'],['/fibre-optique-ftth-gironde','Fibre FTTH Gironde'],['/devenir-sous-traitant-fibre-ftth','Devenir sous-traitant FTTH'],['/conseils','Conseils'],['/en','English version']].map(([p,l]) => <Link key={p} to={p} style={{ color: 'rgba(255,255,255,.6)' }}>{l}</Link>)}
            </div>
          </details>
          <div style={{ textAlign: 'center', color: '#F5B301', fontWeight: 800, fontSize: 13, letterSpacing: '.08em', textTransform: 'uppercase', padding: '16px 0 0' }}>Pros & sous-traitance : toute la France · Particuliers : Nouvelle-Aquitaine</div>
          <div className="ev-footer-bottom">
            <span>© {new Date().getFullYear()} EVOLINK SASU · SIRET 942 623 372 00011 · Photovoltaïque · IRVE · Électricité · Télécom · France entière</span>
            <span style={{ display:'flex', gap:16 }}>
              <Link to="/mentions-legales">Mentions légales</Link>
              <Link to="/cgu">CGU</Link>
            </span>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SiteLayout;
